import React, { useEffect, useState, useRef } from "react";
import Slider from "react-slick";
import styles from './FromVision.module.css'
import { useNavigate, useSearchParams } from "react-router-dom";
import categoryContent from "../../../json/categoryContent.json";

const FROM_VISION_IMAGES = [
  "/Images/latest_drop1.webp",
  "/Images/latest_drop2.webp",
  "/Images/latest_drop3.webp",
];

const FromVision = () => {
    const sliderRef = useRef();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const categorySlug = searchParams.get("category");
    const sectionSlug = searchParams.get("section");

    const isMediaCoverage = categorySlug === "media-pick-ups";
    const allItems = categoryContent[categorySlug]?.items || [];
    const items = isMediaCoverage ? allItems : [];

    const [slidesToShow, setSlidesToShow] = useState(3);
    useEffect(() => {
        const handleResize = () => {
            const width = window.innerWidth;

            if (width <= 650) {
                setSlidesToShow(1);
            } else if (width <= 1024) {
                setSlidesToShow(Math.min(2, items.length || 1));
            } else {
                setSlidesToShow(Math.min(3, items.length || 1));
            }
        };

        handleResize();
        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, [items.length]);

    if (!items.length) return null;

    const settings = {
        infinite: items.length > slidesToShow,
        speed: 600,
        slidesToShow: slidesToShow,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
    };

    return (
      <>
        <section className={styles.wrapper}>
          <div className={styles.container}>
            <h2 className={styles.heading}>More From Vision Care</h2>

            <Slider ref={sliderRef} {...settings}>
              {items.map((item, idx) => (
                <div key={item.id} className={styles.slide}>
                  <div
                    className={styles.card}
                    onClick={() => {
                      if (item.url) {
                        window.open(item.url, "_blank", "noopener,noreferrer");
                      } else {
                        navigate(
                          `/blog-detail?section=${sectionSlug}&category=${categorySlug}`,
                        );
                      }
                    }}
                  >
                    <div className={styles.imageWrapper}>
                      <img
                        src={FROM_VISION_IMAGES[idx % FROM_VISION_IMAGES.length]}
                        alt={item.title}
                      loading="lazy" decoding="async" />
                    </div>

                    <h3 className={styles.cardTitle}>{item.title}</h3>
                    {item.date && <p className={styles.cardDate}>{item.date}</p>}
                    <h3 className={styles.title}>{item.description}</h3>

                    <button className={styles.readMore}>
                      Read more
                      <img src="/svg/arrow_new.svg" alt="arrow_new" loading="lazy" decoding="async" />
                    </button>
                  </div>
                </div>
              ))}
            </Slider>

            <div className={styles.controls}>
              <button
                className={styles.arrowBtn}
                onClick={() => sliderRef.current?.slickPrev()}
              >
                <span className={styles.arrowLeft}></span>
              </button>

              <button
                className={styles.arrowBtn}
                onClick={() => sliderRef.current?.slickNext()}
              >
                <span className={styles.arrowRight}></span>
              </button>
            </div>
          </div>
        </section>
      </>
    );
}

export default FromVision
